import { BLUE, GREEN, NAVY, SLATE } from '../mockupPalette';

export const studentAvatarColors = [BLUE, GREEN, SLATE, NAVY] as const;
export type StudentAvatarColor = typeof studentAvatarColors[number];

export const studentAvatarColorNames: Record<StudentAvatarColor, string> = {
    [BLUE]: 'Blue',
    [GREEN]: 'Green',
    [SLATE]: 'Slate',
    [NAVY]: 'Navy',
};

export function normalizeStudentAvatarColor(color: string | null): StudentAvatarColor {
    const normalized = color?.toUpperCase();
    const legacyColors: Record<string, StudentAvatarColor> = {
        '#0062FF': BLUE,
        '#04A755': GREEN,
        '#28A164': GREEN,
        '#F2994A': SLATE,
        '#2A2459': SLATE,
        '#002A6E': NAVY,
    };
    const currentColor = studentAvatarColors.find(option => option.toUpperCase() === normalized);
    return currentColor ?? (normalized ? legacyColors[normalized] : undefined) ?? studentAvatarColors[0];
}
